/**
 * Unified mobile detection utility
 * Single source of truth for mobile device detection
 * 
 * CRITICAL: For CRITICAL priority videos, use synchronous detection (no useEffect delay)
 */

/**
 * Synchronous mobile detection (no state delay)
 * Use this for CRITICAL priority videos that need immediate loading
 */
export function isMobileDeviceSync(): boolean {
  if (typeof window === 'undefined') return false;
  
  return window.innerWidth <= 768 || 
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Check if viewport is mobile-sized (regardless of device type)
 * Uses 768px breakpoint (md in Tailwind)
 */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
}

/**
 * Check if device is mobile (user agent detection)
 * More reliable for actual device capabilities
 */
export function isMobileUserAgent(): boolean {
  if (typeof window === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**
 * Combined mobile detection (viewport + user agent)
 * Returns true if either viewport is mobile-sized OR device is mobile
 */
export function isMobile(): boolean {
  return isMobileDeviceSync();
}

/**
 * Check if device is desktop (opposite of mobile)
 */
export function isDesktop(): boolean {
  return !isMobileDeviceSync();
}
